import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=70472e18&scoped=true&"
import script from "./EditTag.vue?vue&type=script&lang=ts&"
export * from "./EditTag.vue?vue&type=script&lang=ts&"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=70472e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70472e18",
  null
  
)

export default component.exports